// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Button, Grid2, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { IQuoteDetail } from '~/utils/interface/quotes';
import { DateFormatEnum } from '~/utils/enum/common';
import { formatCurrencyUSD, formatDate } from '~/utils/helper/common';
// Styles, images, icons
import styles from './FeesQuoteDetail.module.scss';
import { icons } from '~/assets';

type Props = {
  detailQuote?: IQuoteDetail;
};

const cx = classNames.bind(styles);

const FeesQuoteDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailQuote } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/quotes', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack className={cx('container')}>
      <BaseLabel styleType='title' label={t('quote_detail_title_fee_summary')} icon={icons.menuIconPurchaseInactive} />

      <Grid2 container spacing={2} className={cx('container')}>
        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_labor_cost', {
              laborCost: formatCurrencyUSD({ value: detailQuote?.laborCost, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_labor_fee', {
              laborFee: formatCurrencyUSD({ value: detailQuote?.laborFee, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_delivery', {
              deliveryCost: formatCurrencyUSD({ value: detailQuote?.deliveryCost, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_damage_waiver', {
              damageWaiver: formatCurrencyUSD({ value: detailQuote?.damageWaiver, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_discount', {
              discount: formatCurrencyUSD({ value: detailQuote?.discountRate, showDecimal: true }),
            })}
          </Typography>
        </Grid2>

        <Grid2 size={4}>
          <Typography className={cx('subTitle')}>
            {t('form_quotes_title_deposit_due', {
              depositDueDate: formatDate(detailQuote?.depositDueDate, DateFormatEnum.MM_DD_YYYY),
            })}
          </Typography>
        </Grid2>

        {detailQuote?.quoteCustom &&
          detailQuote?.quoteCustom.length > 0 &&
          detailQuote?.quoteCustom.map((item, index) => (
            <Grid2 size={4} key={index}>
              <Typography key={index} className={cx('subTitle')}>
                {t('form_quotes_title_fee', {
                  feeName: item?.customFeeName,
                  feeAmount: formatCurrencyUSD({ value: item?.customFeeAmount, showDecimal: true }),
                })}
              </Typography>
            </Grid2>
          ))}
      </Grid2>
    </Stack>
  );
};

export default FeesQuoteDetail;
